import styles from './style.css'

class CustomerInfo extends React.Component {
  render () {
    let {customerDetail} = this.props

    return (customerDetail &&
      <div className='customer-info-box'>
        <div className={'header ' + styles['header-name']}>
          {customerDetail.name || customerDetail.email || customerDetail.phone}
        </div>
        <div className='info-profile'>
          <table>
            <tbody className={styles['no-hover']}>
              <tr>
                <td className={'text-left col-md-6'}>
                  Address
                </td>
                <td className={'text-left col-md-6 wrap-customer-address ' + styles.address}>
                  {customerDetail.address}
                </td>
              </tr>
              <tr>
                <td className='text-left col-md-6'>
                  Phone
                </td>
                <td className='text-left col-md-6'>
                  {customerDetail.phone}
                </td>
              </tr>
              <tr>
                <td className='text-left col-md-6'>
                  Email
                </td>
                <td className={'text-left col-md-6 ' + styles.email}>
                  {customerDetail.email}
                </td>
              </tr>
              <tr>
                <td className='text-left col-md-6'>
                  Birthday
                </td>
                <td className='text-left col-md-6'>
                  {customerDetail.birthday}
                </td>
              </tr>
              <tr>
                <td className='text-left col-md-6'>
                  Gender
                </td>
                <td className='text-left col-md-6'>
                  {customerDetail.sex}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}

CustomerInfo.propTypes = {
  customerDetail: React.PropTypes.object
}

export default CustomerInfo



// WEBPACK FOOTER //
// ./app/pages/Customers/CustomerList/ListLoyalty/CustomerDetail/CustomerInfo.js